import { useEffect, useState, useCallback, useRef } from "react";
import assert from "assert";

import { useGlobalState } from "common/global-state";
import { useWebSocket } from "common/websocket";


interface IOptions {
  clearOnReconnect?: boolean;
}

interface IResult {
  data: Record<string, any>;
}


export function useLiveMeasurements(siteId: string, context: string | null, options?: IOptions): IResult {
  const { clearOnReconnect = false } = options ?? {};
  const { subscribeContext, unsubscribeContext } = useWebSocket();
  const [ data, setData ] = useState<Record<string, any>>({});
  const { user, connected } = useGlobalState();
  const prevConnectedRef = useRef<boolean | null>(null);

  assert(user);

  useEffect(() => {
    if (clearOnReconnect && prevConnectedRef.current === false && connected === true) {
      setData({});
    }
    prevConnectedRef.current = connected;
  }, [connected, clearOnReconnect]);

  const handleData = useCallback((body: any): void => {
    setData((prevData) => {
      if (body.payload === null) {
        const { [body.bucket]: _, ...rest } = prevData;
        return rest;
      }
      return { ...prevData, [body.bucket]: body.payload };
    });
  }, []);


  useEffect(() => {
    if (context) {
      subscribeContext(siteId, context, handleData);

      return () => {
        unsubscribeContext(siteId, context);
      }
    }
  }, [subscribeContext, unsubscribeContext, context, siteId, handleData]);

  return {
    data,
  };
}
